// Move Stripe Express Checkout (Google Pay/Apple Pay) into payment methods section
function moveStripeExpressCheckout() {
    var $expressCheckout = $('#wc-stripe-express-checkout-element');
    var $separator = $('#wc-stripe-express-checkout-button-separator');
    var $orderAttribution = $('#wc-stripe-express-checkout__order-attribution-inputs');
    var $paymentMethods = $('.wc_payment_methods');
    
    // Check if wrapper already exists - prevent duplicates
    if ($('.wc_payment_method_stripe_express').length) {
        return;
    }
    
    // Check if elements exist and payment methods section is available
    if ($expressCheckout.length && $paymentMethods.length) {
        // Create a wrapper for the express checkout inside payment methods
        var $wrapper = $('<li class="wc_payment_method wc_payment_method_stripe_express"></li>');
        
        // Move the button first
        $expressCheckout.appendTo($wrapper);
        
        // Then add the separator after the button
        if ($separator.length) {
            $separator.appendTo($wrapper);
        }
        
        // Insert at the beginning of payment methods
        $paymentMethods.first().prepend($wrapper);
        
        // Move order attribution inputs after the payment methods (hidden but needed for Stripe)
        if ($orderAttribution.length) {
            $orderAttribution.insertAfter($paymentMethods.first());
        }
    }
}

function isGermanCheckout() {
    return document.documentElement.lang.indexOf('de') !== -1 ||
        window.location.pathname.indexOf('/de/') !== -1 ||
        (window.location.pathname.indexOf('/en/') === -1 && window.location.pathname.indexOf('/en') === -1);
}

function isValidEmailAddress(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

// Validate the "Empfänger der Berichte" fields. Field 1 is required, fields 2 & 3
// are only validated when a value is provided. Returns true when all valid.
function validateReportEmails() {
    var message = isGermanCheckout() ? 'Bitte geben Sie eine gültige E-Mail-Adresse ein' : 'Please enter a valid email';
    var valid = true;

    $('#report_email_1, #report_email_2, #report_email_3').each(function() {
        var $input = $(this);
        if (!$input.length) return;

        var $row = $input.closest('.form-row');
        var value = $.trim($input.val());
        var required = $input.attr('id') === 'report_email_1';
        $row.find('.report-email-error').remove();

        var invalid = (required && value === '') || (value !== '' && !isValidEmailAddress(value));

        if (invalid) {
            valid = false;
            $row.addClass('woocommerce-invalid woocommerce-invalid-required-field');
            $('<span class="report-email-error"></span>').text(message).appendTo($row);
        } else {
            $row.removeClass('woocommerce-invalid woocommerce-invalid-required-field');
        }
    });

    return valid;
}

// Clear the custom error as soon as the user corrects the field.
$(document).on('input change', '#report_email_1, #report_email_2, #report_email_3', function() {
    var $input = $(this);
    var value = $.trim($input.val());
    var required = $input.attr('id') === 'report_email_1';
    if ((required ? value !== '' : true) && (value === '' || isValidEmailAddress(value))) {
        var $row = $input.closest('.form-row');
        $row.find('.report-email-error').remove();
        $row.removeClass('woocommerce-invalid woocommerce-invalid-required-field');
    }
});

$('.checkout--btn').click(function(e) {
    e.preventDefault();
    var now = $(this).data('now');
    var step = $(this).data('step');
    var isvalid = true;

    // Only validate when moving forward (next step is greater than current step)
    if(step > now) {
        var $currentStep = $('#checkout_step_' + now);
        $currentStep.find('.validate-required input:not(#terms), .validate-required select').trigger('validate');
        $currentStep.find('.woocommerce-invalid-required-field').each(function(index, element){
            isvalid = false;
        });

        // Report email fields live in step 2; validate them with a custom message.
        if ($currentStep.find('#report_email_1').length && !validateReportEmails()) {
            isvalid = false;
        }
    }
    if(isvalid) {
        $('.checkout--step').addClass('inactive');
        $('#checkout_step_'+step).removeClass('inactive');
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        
        // Move Stripe express checkout when reaching step 3
        // Multiple retries to handle async Stripe loading
        if(step == 3) {
            setTimeout(moveStripeExpressCheckout, 100);
            setTimeout(moveStripeExpressCheckout, 500);
            setTimeout(moveStripeExpressCheckout, 1000);
        }
    }
    return false;
});

$(document).ready(function() {
    $('.woocommerce-additional-fields').prependTo('#checkout_step_2');
    
    // Try to move Stripe express checkout on page load (handles async Stripe loading)
    // The function checks if elements exist and haven't been moved yet
    setTimeout(moveStripeExpressCheckout, 500);
    setTimeout(moveStripeExpressCheckout, 1500); // Retry after longer delay for slow connections

    // Open shop dropdown on page load
    if ($('.shop--dropdown').length) {
        setTimeout(function() {
            var $dropdown = $('.shop--dropdown');
            var $button = $dropdown.find('[popoverbutton="cover"]');
            var $content = $dropdown.find('[popovercontent="cover"]');
            
            if ($button.length && $content.length) {
                $button.addClass('active');
                $content.slideDown();
            }
        }, 100);
    }

    // Add "NEW" badge to orders menu item
    setTimeout(function() {
        var $ordersLink = $('.woocommerce-MyAccount-navigation-link--orders a');
        if ($ordersLink.length && !$ordersLink.find('.new-badge').length) {
            var isGerman = document.documentElement.lang.indexOf('de') !== -1 || 
                          window.location.pathname.indexOf('/de/') !== -1 || 
                          (window.location.pathname.indexOf('/en/') === -1 && window.location.pathname.indexOf('/en') === -1);
            var badgeText = isGerman ? 'NEU' : 'NEW';
            $ordersLink.css({
                'display': 'flex',
                'justify-content': 'space-between',
                'align-items': 'center'
            });
            $ordersLink.append('<span class="new-badge" style="background-color: #e24403; color: white; font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 4px; margin-left: 8px;">' + badgeText + '</span>');
        }
    }, 150);

    setTimeout(function() {
        if($('.wc-block-cart-item__remove-link')) {
            var btnText = $($('.wc-block-cart-item__remove-link')[0]).text();
            if(btnText) {
                $('.wc-block-cart-item__remove-link').html(btnText.replace("Artikel", "Produkt").replace("item", "product"));
            }
        }
        
        // Fix "Proceed to checkout" translation for German
        var isGerman = document.documentElement.lang.indexOf('de') !== -1 || window.location.pathname.indexOf('/de/') !== -1 || (window.location.pathname.indexOf('/en/') === -1 && window.location.pathname.indexOf('/en') === -1);
        if(isGerman) {
            // WooCommerce Cart Block checkout button
            $('.wc-block-cart__submit-button, .wc-block-mini-cart__footer-checkout').each(function() {
                var $btn = $(this);
                if($btn.text().toLowerCase().indexOf('proceed') !== -1 || $btn.text().toLowerCase().indexOf('checkout') !== -1) {
                    $btn.text('Weiter zum Checkout');
                }
            });
            // Classic checkout button
            $('.checkout-button.wc-forward').each(function() {
                var $btn = $(this);
                if($btn.text().toLowerCase().indexOf('proceed') !== -1) {
                    $btn.text('Weiter zum Checkout');
                }
            });
        }
    },100);
    
    // Also run after WooCommerce Blocks finish loading (they load asynchronously)
    setTimeout(function() {
        var isGerman = document.documentElement.lang.indexOf('de') !== -1 || window.location.pathname.indexOf('/de/') !== -1 || (window.location.pathname.indexOf('/en/') === -1 && window.location.pathname.indexOf('/en') === -1);
        if(isGerman) {
            $('.wc-block-cart__submit-button, .wc-block-mini-cart__footer-checkout, .checkout-button.wc-forward').each(function() {
                var $btn = $(this);
                var text = $btn.text().toLowerCase();
                if(text.indexOf('proceed') !== -1 || text === 'checkout') {
                    $btn.text('Weiter zum Checkout');
                }
            });
        }
    }, 500);
});